"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (epoch) {
    return new Date(epoch * 1000).toISOString().slice(11, 19);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/epochToUTCTimeString.js
// module id = 61
// module chunks = 0